import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import { NavItem, NavItemType } from '../../../../Common/Layout/components/Navbar/navbar.component';
import { ResearchRequestDialogComponent } from '../../../../Common/Dialogs/components/ResearchRequestDialog/research-request-dialog.component';

export const nexisSupportNav: NavItem[] =
[
    {
        label: 'Core.navigation.support.supportAndTraining',
        icon: 'fa-duotone fa-regular fa-headset',
        id: 'primaryNavSupport',
        collapsed: true,
        items: [
            {
                label: 'Core.navigation.support.contactSupport',
                type: NavItemType.contactSupport,
                id: 'primaryNavContactSupport'
            },
            {
                label: 'Core.navigation.support.supportLibrary',
                url: 'https://www.agilitypr.com/support/',
                id: 'primaryNavSupportLibrary'
            },
            {
                label: 'Core.navigation.support.submitRequest',
                type: NavItemType.dialog,
                permissions: [
                    userPermissionsEnum.targeting,
                    userPermissionsEnum.advancedTargeting
                ],
                dialogReference: ResearchRequestDialogComponent,
                id: 'primaryNavSubmitResearchRequest',
            }
        ]
    },
    {
        label: 'Core.navigation.support.usage',
        icon: 'fa-duotone fa-regular fa-file-shield',
        id: 'primaryNavUsage',
        collapsed: true,
        items: [
            {
                label: 'Core.navigation.support.policy',
                url: 'https://www.agilitypr.com/privacy-policy/',
                id: 'primaryNavPrivacy'
            },
            {
                label: 'Core.navigation.support.termsOfUse',
                url: 'https://www.agilitypr.com/agility/terms-us/',
                id: 'primaryNavTerms'
            }
        ]
    }
];
